import React, {ChangeEvent} from "react";
import {Errors, PopupState} from "../../../../../flyerDetailsPopup/flyerDetailsRightPanel";
import {Box, Button, Grid, Link, Typography} from "@mui/material";
import {TextInputWithLabel} from "../../../../../../../com/textInputWithLabel/textInputWithLabel";
import {makeStyles} from "@mui/styles";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import RadioButton from "../../../../../../../com/radioButton/RadioButton";
import {ReactComponent as EditIcon} from "../../../../../../../assets/promo_sale_types_icons/edit_icon.svg";
// import {ReactComponent as TrashIcon} from "../../../../../../../assets/editors/delete_icon.svg";
import styles from "../../../../../flyerDetailsPopup/flyerDetailsPopup.module.scss";
import PhoneInput from 'react-phone-number-input'
import {isUnicode} from "../../../../../../../globals/globFunctions";
import {TextareaWithLabel} from "../../../../../../../com/textareaWithLabel/textareaWithLabel";

const useStyles = makeStyles(() => ({
    localAndTextSettingContent: (props: any) => ({
        padding: props.settingForAccount ? `10px 30px` : `0`,
    }),
}))


/*
interface CheckoutTabStateDto {
    checkoutBtn?: string;
    whatsAppMessage?: string;
}
*/


interface Props {
    settingForAccount?: boolean;
    readonly?: boolean;
    data: PopupState;
    changeData?: (popupState: PopupState) => void;
    isNew?: boolean;
    onFulfilmentListChanges: (type: string) => void;
    isFlyerPublished: boolean;
    onChangeCheckoutForCheckoutUrlForAccount?: (e: ChangeEvent<HTMLInputElement>) => void;
    checkoutUrl: string;
    checkoutUrlApp: string;
    editCheckoutUrl: (value: "pcTab" | "appTab") => void;
    deleteCheckoutUrl: VoidFunction;
    deleteCheckoutUrlApp: VoidFunction;
    onFulfilmentTypeChanged: (type: string) => void;
    onChangeEmail: (e: ChangeEvent<HTMLInputElement>) => void;
    onChangePhoneMessage: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    onChangeCheckoutBtnText: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    onChangePhoneNumber: (phoneNumber: string) => void;
    // onChangePhoneNumber: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    stateError: Errors;
    copyDataFromAccountUsingPropertyName: (value: string) => void;
}

export const FlyerCheckoutSettingsForPopup: React.FC<Props> = ({
                                                                   settingForAccount,
                                                                   readonly,
                                                                   data,
                                                                   changeData,
                                                                   isNew,
                                                                   onFulfilmentListChanges,
                                                                   isFlyerPublished,
                                                                   onChangeCheckoutForCheckoutUrlForAccount,
                                                                   checkoutUrl,
                                                                   checkoutUrlApp,
                                                                   editCheckoutUrl,
                                                                   deleteCheckoutUrl,
                                                                   deleteCheckoutUrlApp,
                                                                   onFulfilmentTypeChanged,
                                                                   onChangeEmail,
                                                                   onChangePhoneNumber,
                                                                   stateError,
                                                                   onChangePhoneMessage,
                                                                   onChangeCheckoutBtnText,
                                                                   copyDataFromAccountUsingPropertyName,
                                                               }) => {

    const properties = {
        settingForAccount: settingForAccount
    }
    const classes = useStyles(properties);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);

    const changePhoneNumber = (phoneNumber: string) => {
        onChangePhoneNumber(phoneNumber ? phoneNumber : ``);
    }

    const copyDataFromAccount = (e: React.MouseEvent<HTMLButtonElement>) => {
        const btnName = e.currentTarget as HTMLButtonElement;
        copyDataFromAccountUsingPropertyName(btnName.name);
    }


    return (
        <Box sx={{flex: `1 1 auto`, overflow: "auto"}}>
            <Grid container alignItems={`center`} mb={`16px`} mt={`8px`}>
                <TextInputWithLabel
                    labelGridSizeNumber={4}
                    valueForInput={data.caption}
                    onChangeInput={() => {
                    }}
                    labelCaption={`Job Caption (URL):`}
                    isBold={true}
                    fieldName={`checkoutBtn`}
                    readonly={true}
                    withoutPadding={true}
                />
            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    height: '18px'
                }}
            >
                {
                    !readonly && !isFlyerPublished && data.radioType.isEmail &&
                    <Button
                        name={"valuesForEmail"}
                        disableTouchRipple
                        onClick={copyDataFromAccount}
                    >
                        <Typography sx={{fontSize: `12px`, fontWeight: `bold`, color: `#E5870E`}}
                                    textTransform={`capitalize`}>
                            Copy From Account
                        </Typography>
                    </Button>
                }
            </Box>
            <div
                className={`${styles.section_with_columns} row col-sm-12 ${styles.without_space}`}
            >
                <div
                    className={`col-sm-4 ${styles.without_space} ${styles.caption_field}`}
                >
                    My List Checkout*:
                </div>
                {readonly || isFlyerPublished ? (
                    <div
                        className={`col-sm-8 ${styles.without_space} ${styles.without_space} row`}
                    >
                        <div
                            className={`col-sm-5 ${styles.without_space} ${styles.caption_field}`}
                        >
                            <RadioButton
                                label="Email to:"
                                name="fulfilment_list_option"
                                value={"Email"}
                                checked={data?.radioType.isEmail}
                                onChange={onFulfilmentListChanges}
                                disabled={readonly || isFlyerPublished}
                            />
                        </div>
                        <div
                            className={`${
                                isNew ? "" : styles.read_only
                            } col-sm-7 ${styles.without_space}`}
                        >
                            {data?.email}
                            <div
                                className={`col-sm-12 shopping_list_fulfillment_chckboxes ${styles.without_space} row ${styles.radio_btn_for_excel_or_text}`}
                            >
                                <RadioButton
                                    label="Excel"
                                    name="fulfilment_file_type_new"
                                    value={"Excel"}
                                    checked={data?.radioType.excel}
                                    onChange={onFulfilmentTypeChanged}
                                    disabled={readonly || isFlyerPublished}
                                />
                                <RadioButton
                                    label="Text"
                                    name="fulfilment_file_type_new"
                                    value={"Text"}
                                    checked={data.radioType.text}
                                    onChange={onFulfilmentTypeChanged}
                                    disabled={readonly || isFlyerPublished}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={`col-sm-8 ${styles.without_space} row`}>
                        <div className={`col-sm-12 row ${styles.without_space}`}>
                            <div
                                className={`col-sm-5 ${styles.without_space} ${styles.caption_field}`}
                            >
                                <RadioButton
                                    label="Email to:"
                                    name="fulfilment_list_option"
                                    value={"Email"}
                                    checked={data.radioType.isEmail}
                                    onChange={onFulfilmentListChanges}
                                    disabled={readonly || isFlyerPublished}
                                />
                            </div>
                            <div className={`col-sm-7 ${styles.without_space}`}>
                                <input
                                    className={`col-sm-12 
                                        ${styles.without_space}
                                        ${data.radioType.isEmail && styles.requiredField} 
                                        ${stateError.emailErr && data.radioType.isEmail ? styles.error_signal : ''}
                                    `}
                                    type="url"
                                    value={data.email}
                                    onChange={onChangeEmail}
                                    maxLength={100}
                                    placeholder={`example@gmail.com`}
                                />
                                <div
                                    className={`col-sm-12 shopping_list_fulfillment_chckboxes ${styles.without_space} row ${styles.radio_btn_for_excel_or_text}`}
                                >
                                    <RadioButton
                                        label="Excel"
                                        name="fulfilment_file_type_new"
                                        value={"Excel"}
                                        checked={data.radioType.excel}
                                        onChange={onFulfilmentTypeChanged}
                                        disabled={readonly || isFlyerPublished}
                                    />
                                    <RadioButton
                                        label="Text"
                                        name="fulfilment_file_type_new"
                                        value={"Text"}
                                        checked={data.radioType.text}
                                        onChange={onFulfilmentTypeChanged}
                                        disabled={readonly || isFlyerPublished}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <Grid container alignItems={`center`} justifyContent={`flex-end`}
                  sx={{mb: `20px`}}>
                <Grid item xs={8}>
                    <Grid container my={`10px`}>
                        <Grid item xs>
                            <RadioButton
                                label="Checkout URL:"
                                name="fulfilment_list_option"
                                value={"URL"}
                                checked={data?.radioType.isUrl}
                                onChange={onFulfilmentListChanges}
                                disabled={readonly || isFlyerPublished}
                            />
                        </Grid>
{/*
                        {
                            data?.radioType.isUrl && !readonly && !isFlyerPublished &&
                            <Grid item xs={7}>
                                <Box sx={{display: `flex`, alignItems: `center`}}>
                                    <Checkbox
                                        checked={data?.isSelectAccountCheckoutUrl}
                                        onChange={onChangeCheckoutForCheckoutUrlForAccount}
                                        // checkedIcon={<CheckedIcon />}
                                        inputProps={{'aria-label': 'controlled'}}
                                        sx={{
                                            padding: `0`,
                                            marginRight: `5px`
                                        }}
                                        disabled={
                                            readonly ||
                                            isFlyerPublished }
                                    />
                                    <Typography sx={{
                                        marginRight: `5px`,
                                        lineHeight: `15px`,
                                        fontSize: `14px`,
                                        fontFamily: `revert`
                                    }}>
                                        Account checkout URL
                                    </Typography>
                                </Box>
                            </Grid>

                        }
*/}
                    </Grid>
                    <Box
                        sx={{
                            display: "flex",
                            flexFlow: "column",
                            rowGap: "16px",
                            paddingLeft: "25px"
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexFlow: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Typography fontSize={"14px"} color={"#808080"}>
                                    Target Web/PC:
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        columnGap: "8px",
                                        height: '30px'
                                    }}
                                >
                                    {
                                        !isFlyerPublished &&
                                        !readonly &&
                                        !(flyerDetailsState.flyRecId === 0) &&
                                        data?.radioType.isUrl &&
                                        <>
                                            <Box sx={{ml: `5px`}}>
                                                <Button
                                                    sx={{padding: `5px`, width: `30px`, height: `30px`}}
                                                    onClick={() => {
                                                        editCheckoutUrl("pcTab");
                                                    }}>
                                                    <EditIcon/>
                                                </Button>
                                            </Box>
                                            {/*<Box sx={{ml: `5px`}}>*/}
                                            {/*    <Button*/}
                                            {/*        sx={{*/}
                                            {/*            padding: `5px`,*/}
                                            {/*            width: `30px`,*/}
                                            {/*            height: `30px`,*/}
                                            {/*            opacity: !Boolean(checkoutUrl) ? `0.5` : `1`*/}
                                            {/*        }}*/}
                                            {/*        disabled={!Boolean(checkoutUrl)}*/}
                                            {/*        onClick={deleteCheckoutUrl}*/}
                                            {/*    >*/}
                                            {/*        <TrashIcon/>*/}
                                            {/*    </Button>*/}
                                            {/*</Box>*/}
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end'
                                                }}
                                            >
                                                <Button
                                                    name={"urlLinkForPc"}
                                                    disableTouchRipple
                                                    disabled={isFlyerPublished}
                                                    onClick={copyDataFromAccount}
                                                >
                                                    <Typography
                                                        sx={{fontSize: `12px`, fontWeight: `bold`, color: `#E5870E`}}
                                                        textTransform={`capitalize`}>
                                                        Copy From Account
                                                    </Typography>
                                                </Button>
                                            </Box>

                                        </>
                                    }
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    display: `flex`,
                                    alignItems: `center`,
                                }}
                            >
                                {
                                    checkoutUrl &&
                                    <Link href={checkoutUrl} underline="always" rel="noreferrer"
                                          target="_blank"
                                          sx={{wordBreak: `break-all`}}>
                                        {checkoutUrl}
                                    </Link>
                                }
                                {
                                    !checkoutUrl &&
                                    <Typography color={"#808080"}>
                                        Not selected
                                    </Typography>
                                }
                            </Box>
                        </Box>
                        <Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexFlow: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Typography fontSize={"14px"} color={"#808080"}>
                                    Target App/Mobile:
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        columnGap: "8px",
                                        height: '30px'
                                    }}
                                >
                                    {
                                        !isFlyerPublished &&
                                        !readonly &&
                                        data?.radioType.isUrl &&
                                        !(flyerDetailsState.flyRecId === 0) &&
                                        <>
                                            <Box sx={{ml: `5px`}}>
                                                <Button
                                                    sx={{padding: `5px`, width: `30px`, height: `30px`}}
                                                    onClick={() => {
                                                        editCheckoutUrl("appTab");
                                                    }}>
                                                    <EditIcon/>
                                                </Button>
                                            </Box>
                                            {/*<Box sx={{ml: `5px`}}>*/}
                                            {/*    <Button*/}
                                            {/*        sx={{*/}
                                            {/*            padding: `5px`,*/}
                                            {/*            width: `30px`,*/}
                                            {/*            height: `30px`,*/}
                                            {/*            opacity: !Boolean(checkoutUrlApp) ? `0.5` : `1`*/}
                                            {/*        }}*/}
                                            {/*        disabled={!Boolean(checkoutUrlApp)}*/}
                                            {/*        onClick={deleteCheckoutUrlApp}*/}
                                            {/*    >*/}
                                            {/*        <TrashIcon/>*/}
                                            {/*    </Button>*/}
                                            {/*</Box>*/}
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end'
                                                }}
                                            >
                                                <Button
                                                    name={"urlLinkForApp"}
                                                    disableTouchRipple
                                                    disabled={isFlyerPublished}
                                                    onClick={copyDataFromAccount}
                                                >
                                                    <Typography
                                                        sx={{fontSize: `12px`, fontWeight: `bold`, color: `#E5870E`}}
                                                        textTransform={`capitalize`}>
                                                        Copy From Account
                                                    </Typography>
                                                </Button>
                                            </Box>
                                        </>
                                    }
                                </Box>
                            </Box>
                            <Box sx={{
                                display: `flex`,
                            }}>
                                {checkoutUrlApp &&
                                    <Link href={checkoutUrlApp} underline="always" rel="noreferrer"
                                          target="_blank"
                                          sx={{wordBreak: `break-all`}}>
                                        {checkoutUrlApp}
                                    </Link>
                                }

                                {
                                    !checkoutUrlApp &&
                                    <Typography color={"#808080"}>
                                        Not selected
                                    </Typography>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    height: '18px'
                }}
            >
                {
                    !readonly && !isFlyerPublished && data.radioType.isPhoneNumber &&
                    <Button
                        name={"valuesForWhatsApp"}
                        disableTouchRipple
                        onClick={copyDataFromAccount}
                    >
                        <Typography sx={{fontSize: `12px`, fontWeight: `bold`, color: `#E5870E`}}
                                    textTransform={`capitalize`}>
                            Copy From Account
                        </Typography>
                    </Button>
                }
            </Box>
            <Grid container alignItems={`center`} justifyContent={`flex-end`}>
                <Grid item xs={8}>
                    <Grid container mt={`10px`} mb={"4px"}>
                        <Grid item xs>
                            <RadioButton
                                label="WhatsApp:"
                                name="fulfilment_list_option"
                                value={"PhoneNumber"}
                                checked={data?.radioType.isPhoneNumber}
                                onChange={onFulfilmentListChanges}
                                disabled={readonly || isFlyerPublished}
                            />
                        </Grid>
                        <Grid item xs={7}>
                            <Box sx={{display: `flex`, alignItems: `center`, width: `100%`}}>
                                <PhoneInput
                                    style={{
                                        width: `100%`,
                                    }}
                                    className={`
                                        ${styles.phoneInput} 
                                        ${data.radioType.isPhoneNumber && styles.requiredField} 
                                        ${stateError.phoneNumberErr && data.radioType.isPhoneNumber ? styles.error_signal : ''}
                                    `}
                                    placeholder="Enter phone number"
                                    value={data.phoneNumber}
                                    onChange={changePhoneNumber}
                                    disabled={readonly || isFlyerPublished}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container alignItems={`center`} justifyContent={`flex-end`}
                  sx={{mb: `20px`}}>
                <Grid item xs={8}>
                    <Grid container my={`4px`} justifyContent={`flex-end`}>
                        <Grid item xs={7}>
                            <Box sx={{display: `flex`, flexFlow: "column", width: `100%`, rowGap: "5px"}}>
                                <Typography fontFamily={"inherit"} fontSize={"14px"}>
                                    Message:
                                </Typography>
                                <Grid container alignItems={`center`}>
                                    <TextInputWithLabel
                                        direction={isUnicode(data.phoneMessage ? data.phoneMessage : ``) ? `rtl` : `ltr`}
                                        valueForInput={data.phoneMessage}
                                        onChangeInput={onChangePhoneMessage}
                                        isBold={true}
                                        fieldName={`whatsAppMessage`}
                                        maxLength={100}
                                        readonly={readonly || isFlyerPublished}
                                        isRequired={data.radioType.isPhoneNumber}
                                        isNotValid={stateError.phoneMessageErr && data.radioType.isPhoneNumber}
                                    />
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box className={classes.localAndTextSettingContent}>
                {/*rows*/}
                <Grid container alignItems={`center`}>
                    <TextareaWithLabel
                        labelGridSizeNumber={4}
                        valueForInput={data.uiText?.goToCheckout || ""}
                        onChangeInput={onChangeCheckoutBtnText}
                        labelCaption={`Checkout Button Text:`}
                        isBold={true}
                        fieldName={`checkoutBtn`}
                        maxLength={30}
                        readonly={readonly || isFlyerPublished}
                        isRequired={true}
                        isNotValid={stateError.checkoutBtnCaptionErr ? stateError.checkoutBtnCaptionErr : false}
                    />
                </Grid>
            </Box>
        </Box>
    )
}